import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Paper,
} from "@mui/material";
import { auth } from "../firebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await signInWithEmailAndPassword(auth, email, password);
      window.location.href = "/";
    } catch (err) {
      setError(
        "E-posta adresiniz veya şifreniz hatalı.Lütfen tekrar deneyiniz."
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundImage:
          "radial-gradient(circle, #582b70, #442759, #332142, #231b2b, #141315)",
      }}
    >
      <Container component="main" maxWidth="xs">
        <Paper
          elevation={3}
          sx={{
            padding: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src="/tzv-logo.png"
              alt="tzv"
              style={{ width: "200px", marginBottom: "20px" }}
            />
            <Typography
              component="h1"
              variant="h5"
              sx={{
                marginBottom: "20px",
                color: "#582b70",
                fontWeight: "bold",
              }}
            >
              Belge Yönetim Sistemi
            </Typography>
            {error && (
              <Typography
                color="error"
                variant="body2"
                sx={{ marginBottom: "20px" }}
              >
                {error}
              </Typography>
            )}
            <Box
              component="form"
              noValidate
              onSubmit={handleLogin}
              sx={{ mt: 1 }}
            >
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                placeholder="E-posta adresi giriniz"
                id="email"
                name="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                placeholder="Şifre giriniz"
                fullWidth
                name="password"
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2, backgroundColor: "#582b70" }}
              >
                Giriş Yap
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
